<template>
    <div>
        <report-header
            :title="title"
        />
        <b-card>
            <div v-if="!loaded">
                <img src="assets/ajax-loader.gif" style="padding: 10px;" />
            </div>
            <div id="report-body" v-if="loaded" class="w-100">
                <div v-if="result.length > 0">
                    <b-table-simple bordered>
                        <QVirtualScroll
                            :items="result"
                            type="table"
                            :virtual-scroll-item-size="44"
                            scroll-target="body"
                        >
                            <template v-slot:before>
                                <b-thead head-variant="dark">
                                    <b-tr>
                                        <b-th style="width: 9%;"
                                            >First Name</b-th
                                        >
                                        <b-th style="width: 9%;"
                                            >Last Name</b-th
                                        >
                                        <b-th style="width: 5%;">ID</b-th>
                                        <b-th style="width: 8.5%;"
                                            >Primary Reminder Preference</b-th
                                        >
                                        <b-th style="width: 25%;">Address</b-th>
                                        <b-th style="width: 8.5%;">County</b-th>
                                        <b-th style="width: 8.5%;"
                                            >Country</b-th
                                        >
                                        <b-th style="width: 8.5%;"
                                            >Home Phone</b-th
                                        >
                                        <b-th style="width: 8.5%;"
                                            >Mobile Phone</b-th
                                        >
                                        <b-th style="width: 8.5%;">Email</b-th>
                                        <b-th style="width: 8.5%;"
                                            >Referred By</b-th
                                        >
                                        <b-th
                                            v-if="isRecordSharing"
                                            style="width: 8.5%;"
                                            >Home Location</b-th
                                        >
                                    </b-tr>
                                </b-thead>
                            </template>
                            <template v-slot="{ item: data, index }">
                                <tr :key="index">
                                    <b-td>
                                        <router-link
                                            v-if="USE_CLIENT_MODULE_VUE"
                                            :to="`/client/profile/${data.client_id}?encoded=0`"
                                        >
                                            {{ data.first_name_string }}
                                        </router-link>
                                        <a v-else :href="getClientURI(data)">
                                            {{ data.first_name_string }}
                                        </a>
                                    </b-td>
                                    <b-td>
                                        <router-link
                                            v-if="USE_CLIENT_MODULE_VUE"
                                            :to="`/client/profile/${data.client_id}?encoded=0`"
                                        >
                                            {{ data.last_name_string }}
                                        </router-link>
                                        <a v-else :href="getClientURI(data)">
                                            {{ data.last_name_string }}
                                        </a>
                                    </b-td>
                                    <b-td>{{ data.client_index }}</b-td>
                                    <b-td>{{
                                        data.primary_reminder_preference
                                    }}</b-td>
                                    <b-td>{{ formatAddress(data) }}</b-td>
                                    <b-td>{{ data.county }}</b-td>
                                    <b-td>{{ data.country }}</b-td>
                                    <b-td>{{ data.home_phone }}</b-td>
                                    <b-td>{{ data.mobile_phone }}</b-td>
                                    <b-td>{{ data.email }}</b-td>
                                    <b-td>{{ data.referredBy }}</b-td>
                                    <b-td v-if="isRecordSharing">{{
                                        data.home_location
                                    }}</b-td>
                                </tr>
                            </template>
                        </QVirtualScroll>
                    </b-table-simple>
                </div>
                <div v-else>
                    <i>No records available</i>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import { Quasar, QVirtualScroll } from "quasar";
import Vue from "vue";
import Report from "@/mixins/report";
Vue.use(Quasar, {
    components: {
        QVirtualScroll
    }
});
export default {
    components: {
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            meta: "",
            code: "",
            result: [],
            renderedDateTime: moment().format("lll"),
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true",
            rowHeight: 44,
            title: "Active Client List"
        };
    },
    mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.filterDateOption = false;

        self.init();
        self.$root.$on("active_client_list:refresh", function () {
            self.init();
        });
    },
    beforeDestroy: function () {
        this.data.filterDateOption = true;
    },
    methods: {
        init() {
            let self = this;
            self.loaded = false;

            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "/report/reports/" +
                        self.$route.params.id
                )
                .then(function (response) {
                    self.meta = response.data.response.resource.meta;
                    self.result = response.data.response.resource.results;
                    self.isRecordSharing =
                        response.data.response.resource.isRecordSharing;
                    self.locale = self.meta.locale.replace("_", "-");
                    self.code = response.status;
                    self.dynamicPageTitle(self.title);
                    if (self.code === 200) {
                        self.loaded = true;
                        self.renderedDateTime = moment().format("lll");
                    }
                });
        },
        getClientURI(data) {
            return (
                process.env.CI_APPS +
                "client/client/view/" +
                data.client_id +
                "/0"
            );
        },
        formatAddress(data) {
            let address = [
                data.address,
                data.city,
                data.state,
                data.zipcode,
                data.country
            ];

            address = jQuery.grep(address, function (i) {
                return i !== null && i !== "";
            });

            return address.join(", ", address);
        }
    }
};
</script>
